module.exports = __webpack_public_path__ + "img/key-white-c.0abb8164.svg";